export const ENDPOINTS = {
  LOGIN: {
    SAP_INTEG_LOGIN: "/sap-integ-login",
  },
};
